import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { i18n, init as i18nInit } from 'src/i18n';
import { AuthToken } from './modules/auth/authToken';
import TenantService from './modules/tenant/tenantService';
import SettingsService from './modules/settings/settingsService';

function AppInitializer() {
  const location = useLocation();
  useEffect(() => {
    (async function () {
      const isUpcomingEvents = location.pathname.startsWith('/events') || location.pathname === '/';
      AuthToken.applyFromLocationUrlIfExists();
      await TenantService.fetchAndApply(!isUpcomingEvents);
      if(!isUpcomingEvents) {
        SettingsService.applyThemeFromTenant();
      }      
      await i18nInit();
      const App = require('./App').default;
      document.title = i18n('app.title');
      ReactDOM.render(<App />, document.getElementById('root'));
    })();
  }, [location]); 

  return null; 
}

ReactDOM.render(
  <Router>
    <AppInitializer />
  </Router>,
  document.getElementById('root'),
);
